import { defineMessages } from 'react-intl';

export default defineMessages({
    umbrellaCoverage: {
        id: 'ml.quoteandbind.pupeditcoverages.umbrellaCoverage',
        defaultMessage: 'Umbrella Coverage'
    },
    yourUmbrellaCoverage: {
        id: 'ml.quoteandbind.pupeditcoverages.yourUmbrellaCoverage',
        defaultMessage: 'Your umbrella coverage'
    },
    thisIsASnapshot: {
        id: 'ml.quoteandbind.pupeditcoverages.thisIsASnapshot',
        defaultMessage: 'This is a snapshot of the coverages, limits and premium for your umbrella policy. Coverage can be customized.'
    },
    editCoverage: {
        id: 'ml.quoteandbind.pupeditcoverages.editCoverage',
        defaultMessage: 'EDIT COVERAGE'
    },
    optionalCoverages: {
        id: 'ml.quoteandbind.pupeditcoverages.optionalCoverages',
        defaultMessage: 'Optional Coverages'
    },
    exclusions: {
        id: 'ml.quoteandbind.pupeditcoverages.exclusions',
        defaultMessage: 'Exclusions'
    },
    premium: {
        id: 'ml.quoteandbind.pupeditcoverages.premium',
        defaultMessage: 'Premium'
    },
    premiumTooltipLabel: {
        id: 'ml.quoteandbind.pupeditcoverages.premiumTooltipLabel',
        defaultMessage: 'What is not included in this premium?'
    },
    premiumTooltipContent: {
        id: 'ml.quoteandbind.pupeditcoverages.premiumTooltipContent',
        defaultMessage: 'The premium shown does not include fees or taxes.'
    }
});
